import React from 'react';
import { Breadcrumb, Button, Divider,Space,Typography } from 'antd';
import sequence from '../../assets/images/sequence.png';
import body from '../../assets/images/json.png';

const {Title,Paragraph,Text} = Typography;

const Documentation = () => {
  const data=[{
                id:1,
                code:'200',
                short:'OK',
                description:'Everything worked as expected '
              },
              {
                id:2,
                code:'400',
                short:'Bad requests',
                description:'The request was not accepted due particular parameter not meeting required condition'
              },
              {
                id:3,
                code:'401',
                short:'Unauthorised ',
                description:'No valid API key provided'
              },
              {
                id:4,
                code:'402',
                short:'Request failed',
                description:"The API key doesn't have permissions to perform the request"
              },
              {
                id:5,
                code:'500, 501, 502, 503, 504',
                short:'Server Errors',
                description:'Something went wrong on C-Pay end. (These are rare.)'
              }]

 const Headers=[{
                id:1,
                key:'Authorization',
                value:'<API Key>',
              },
              {
                id:2,
                key:'Content Type',
                value:'Application / JSON'
              }]            
  return ( 
  <div style={{margin:'8% 5%'}}>
    <Title level={1} style={{color:'#00b33c'}}>Chaperone Payment Gateway</Title>
    <Divider orientation="left">
      <Title level={3} style={{color:'#00b33c'}}>Introduction</Title>
    </Divider>
    <Paragraph style={{fontSize:16}}>
    The Chaperone Pay gateway is a service provided to merchants to enable them accept 
    payments from their websites. The gateway is organized around Rest. 
     It accepts form-encoded request bodies and returns JSON encoded responses.
     It utilizes standard HTTP response codes, authentication, and verbs.
     C-Pay gateway can be used in test mode, which does not affect your live data. 
     The C-Pay gateway key you use to authenticate the request determines whether the request
      is live mode or test mode.
    </Paragraph>
    <Divider><Title level={3} style={{color:'#00b33c'}}>Overview</Title></Divider>
    <Divider orientation="left">
      <Title level={3} style={{color:'#00b33c'}}>Objectives</Title>
    </Divider>
    <Paragraph>
      <ul>
        <li>
          <Text  style={{fontSize:16}}>Actor: An individual using the ecommerce application.</Text>
        </li>
        <li>
          <Text  style={{fontSize:16}}>Application: Ecommerce application which C-Pay as a payment option and has access to the gateway.</Text>
        </li>
        <li>
          <Text  style={{fontSize:16}}>C-Pay Gateway: The chaperone Pay Payments API which manages integration of the C-Pay platform to external parties.</Text>
        </li>
      </ul>
    </Paragraph>
    <Divider orientation="left">
      <Title level={3} style={{color:'#00b33c'}}>Payment Process Steps</Title>
    </Divider>
    <Paragraph>
      <ol>
        <li>
          <Text  style={{fontSize:16}}>When a user checks out from the application 
          or does any operation that requires payment in the Application, then they will be offered
          C-Pay as a payment method
          </Text>
        </li>
        <li>
          <Text  style={{fontSize:16}}>They should provide a mobile number of their C-Pay account they
            wish to use for the transactions and initiate the transaction.
            </Text>
        </li>
        <li>
          <Text  style={{fontSize:16}}>The application will send a payment request to the C-Pay Gateway
          with mobile number, amount and any other relevant information.
          </Text>
        </li>
        <li>
          <Text  style={{fontSize:16}}>The API generates the OTP and sends it to the user.
          </Text>
        </li>
        <li>
          <Text  style={{fontSize:16}}>The user will then enter the OTP on to the application to initiate the
            confirmation of the transaction.
          </Text>
        </li>
        <li>
          <Text  style={{fontSize:16}}>The application will submit transaction confirmation to the API.
          </Text>
        </li>
        <li>
          <Text  style={{fontSize:16}}>The API then processes the transaction and returns a success or
          failed message.
          </Text>
        </li>
        <li>
          <Text  style={{fontSize:16}}>Then the user also receives an SMS notification with details about
          the success or failure of transaction.
         </Text>
        </li>
      </ol>
    </Paragraph>
    <Title level={3} style={{color:'#00b33c'}}>Sequence  Diagram :</Title>
    <img src={sequence} width='70%'/>
    <Divider orientation="left">
      <Title level={3} style={{color:'#00b33c'}}>Authentication</Title>
    </Divider>
    <Paragraph style={{fontSize:16}}>
    The C-Pay gateway uses API keys to authenticate requests.<br/>
    Your API keys carry many privileges, so be sure to keep them secure! 
    Do not share your secret API keys in publicly accessible areas such as GitHub, client-side code, and so forth.<br/>
    Authentication to the API is performed via HTTP <b>Authorization</b> header. Provide your API key as the <b>Authorization</b> value.<br/>
    All API requests must be made over HTTPS. Calls made over plain HTTP will fail. API requests without authentication will also fail.
    </Paragraph>
    <Divider orientation="left">
      <Title level={3} style={{color:'#00b33c'}}>Error</Title>
    </Divider>
    <Paragraph style={{fontSize:16}}>C-Pay gateway uses conventional HTTP response codes to indicate the success or failure of an API request. In general: Codes in the <b>2xx</b> range indicate success. Codes in the <b>4xx</b> range indicate an error that failed given the information provided (e.g., a required parameter was omitted, a charge failed, etc.).
     Codes in the <b>5xx</b> range indicate an error with C-Pay servers (these are rare).<br/> 
     Some <b>4xx</b> errors that could be handled programmatically (e.g., a card is declined or OTP expired) include an error code that briefly explains the error reported.
    </Paragraph>
    <div className="doc_table table-responsive">
        <table className="width-100">
          <thead>
            <tr>
              <th>Error Code</th>
              <th>Short Description</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((data) => (
              <tr key={data.id}>
                <td>
                  <h6>
                    {data.code}
                  </h6>
                </td>
                <td>
                <h6>{data.short}</h6>
                </td>
                <td>
                <h6>{data.description}</h6>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        <br/>
        <Divider/>
      <Divider><Title level={3} style={{color:'#00b33c'}}>Payment Requests</Title></Divider>
      <Divider orientation="left">
        <Title level={3} style={{color:'#00b33c'}}>Payment Initiation</Title>
      </Divider>
      <h2>End point:</h2>
      <Breadcrumb style={{fontSize:16}}>
        <Breadcrumb.Item>api</Breadcrumb.Item>
        <Breadcrumb.Item>
          <a href="">cpaypayments</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a href="">payment</a>
        </Breadcrumb.Item>
      </Breadcrumb>
      <br/>

      <h2>Request Headers:</h2>
      <div className="doc_table table-responsive">
        <table className="width-100">
          <thead>
            <tr>
              <th>Key</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {Headers?.map((data) => (
              <tr key={data.id}>
                <td>
                  <h6>
                    {data.key}
                  </h6>
                </td>
                <td>
                <h6>{data.value}</h6>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        <br></br>
        <h2>Body:</h2>
        <img src={body} width='70%'/>
        <h2>Transaction Object:</h2>
        <Paragraph>
          <ul>
            <li>
              <Text  style={{fontSize:16}}><b>ExtTrasactionId:</b> string<br/>
                Unique identifier for the object.
              </Text>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>ClientCode:</b> string<br/>
                Identifier for the connecting client
              </Text>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>msisdn:</b> string <br/>
               Attribute that identifies the transaction customer, it can neither be an email, msisdn or username
              </Text>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>Currency:</b> string<br/>
               ISO 4217(3 letters) representing the currency of a particular transaction
              </Text>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>Amount:</b> decimal<br/>
              Two decimal place amounts for the transaction
              </Text>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>OtpMedium:</b> string<br/>
                Attribute which identifies the medium through which the user shall receive their OTP for the transaction.
                It could be either <b>sms or email.</b>
                </Text>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>Checksum:</b> string<br/>
              The value is generated by combining or concatenating the above attributes and apply 
              the HMACSHA256(salt, secret) and return the hexadecimal representation of created hash.
              </Text><br/>
              <Space direction='horizontal'>
                <Paragraph style={{fontSize:16}}><b>Implementations for the HMACSHA256 method: </b></Paragraph>
                <a href='https://www.jokecamp.com/blog/examples-of-creating-base64-hashes-using-hmac-sha256-in-different-languages/'
                style={{color:'white',backgroundColor:'#00b33c',marginBottom:100,borderRadius:10,padding:5,textDecoration:'none'}}>click here
                </a>
              </Space>
              <br/>
              <Paragraph style={{fontSize:16}}><b>Salt = ExtTransactionalId + ClientCode + Amount + MSISDN</b></Paragraph>
              
              <Paragraph style={{fontSize:16}}><b>Secret will be provided along with the API Key</b></Paragraph>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>RedirectUrl:</b> string(optional)<br/>
              The confirmation URL of the connecting client

              </Text>
            </li>
          </ul>
        </Paragraph>
        <br/>
        <Divider/>


      <Divider><Title level={3} style={{color:'#00b33c'}}>Payment Confirmation</Title></Divider>
      <Divider orientation="left">
        <Title level={3} style={{color:'#00b33c'}}>Payment Initiation</Title>
      </Divider>
      <h2>End point:</h2>
      <Breadcrumb style={{fontSize:16}}>
        <Breadcrumb.Item>api</Breadcrumb.Item>
        <Breadcrumb.Item>
          <a href="">cpaypayments</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a href="">confirm</a>
        </Breadcrumb.Item>
      </Breadcrumb>
      <br/>

      <h2>Request Headers:</h2>
      <div className="doc_table table-responsive">
        <table className="width-100">
          <thead>
            <tr>
              <th>Key</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {Headers?.map((data) => (
              <tr key={data.id}>
                <td>
                  <h6>
                    {data.key}
                  </h6>
                </td>
                <td>
                <h6>{data.value}</h6>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        <br></br>
        <h2>Body:</h2>
        <img src={body} width='70%'/>
        <h2>Transaction Object:</h2>
        <Paragraph>
          <ul>
            <li>
              <Text  style={{fontSize:16}}><b>ExtTrasactionId:</b> string<br/>
                Unique identifier for the object.
              </Text>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>ClientCode:</b> string<br/>
                Identifier for the connecting client
              </Text>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>msisdn:</b> string <br/>
               Attribute that identifies the transaction customer, it can neither be an email, msisdn or username
              </Text>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>Currency:</b> string<br/>
               ISO 4217(3 letters) representing the currency of a particular transaction
              </Text>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>Amount:</b> decimal<br/>
              Two decimal place amounts for the transaction
              </Text>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>OTP:</b> string<br/>
                Attribute which identifies the medium through which the user shall receive their OTP for the transaction.
                It could be either <b>sms or email.</b>
                </Text>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>Checksum:</b> string<br/>
              The value is generated by combining or concatenating the above attributes and apply 
              the HMACSHA256(salt, secret) and return the hexadecimal representation of created hash.
              </Text><br/>
              <Space direction='horizontal'>
                <Paragraph style={{fontSize:16}}><b>Implementations for the HMACSHA256 method: </b></Paragraph>
                <a href='https://www.jokecamp.com/blog/examples-of-creating-base64-hashes-using-hmac-sha256-in-different-languages/'
                style={{color:'white',backgroundColor:'#00b33c',marginBottom:100,borderRadius:10,padding:5,textDecoration:'none'}}>click here
                </a>
              </Space>
              <br/>
              <Paragraph style={{fontSize:16}}><b>Salt = ExtTransactionalId + ClientCode + Amount + MSISDN+OTP</b></Paragraph>
              
              <Paragraph style={{fontSize:16}}><b>Secret will be provided along with the API Key</b></Paragraph>
            </li>
            <li>
              <Text  style={{fontSize:16}}><b>RedirectUrl:</b> string(optional)<br/>
              The confirmation URL of the connecting client

              </Text>
            </li>
          </ul>
        </Paragraph>
  </div>
  )
}

export default Documentation